import React, { memo } from 'react';
import { blockDefForFigure } from '../../lib/rhythm/ecoRitmoConfig';
import { laneXAtY } from '../../lib/percusionCorporal';
import type { LaneLayout } from '../../lib/percusionPerspective';
import type { RhythmBubble } from '../../lib/game/atrapaRitmoEngine';
import { RhythmFigureIcon } from '../ecoRitmico/RhythmFigureIcon';

interface AtrapaRhythmBlocksProps {
  bubbles: RhythmBubble[];
  laneLayouts: LaneLayout[];
  horizonY: number;
}

export const AtrapaRhythmBlocks = memo(function AtrapaRhythmBlocks({
  bubbles,
  laneLayouts,
  horizonY,
}: AtrapaRhythmBlocksProps) {
  return (
    <>
      {bubbles.map((b) => {
        const block = blockDefForFigure(b.figureId);
        const x = laneXAtY(b.lane, b.y, laneLayouts);
        const depth = Math.min(1, b.y / Math.max(horizonY, 1));
        const scale = 0.62 + depth * 0.38;
        const size = b.radius * 2 * scale;
        const opacity = b.hit || b.missed ? 1 - b.popT : 1;
        if (opacity <= 0) return null;

        return (
          <div
            key={b.id}
            className={`ar-rhythm-block absolute pointer-events-none flex items-center justify-center ${
              b.hit ? 'ar-rhythm-block--hit' : ''
            }`}
            style={{
              left: x - size / 2,
              top: b.y - size / 2,
              width: size,
              height: size,
              background: block.bg,
              color: block.color,
              opacity,
            }}
            aria-hidden
          >
            <RhythmFigureIcon
              figureId={b.figureId}
              size={size * 0.78}
              color={block.color}
            />
          </div>
        );
      })}
    </>
  );
});

export default AtrapaRhythmBlocks;
